import PropTypes from 'prop-types';
import styles from './blogHome.module.scss';
import HeroTemplate from '../heroTemplate/heroTemplate';
import FullBGCard from '../fullBgCard/fullBgCard';
import BlogPostList from '../blogPostList/blogPostList';
import LcResources from '../lcResources/lcResources';

function BlogHome({
  hero = null,
  latestPosts = [],
  productBasedPosts = [],
  fullBgCard = null,
  lcResources = [],
}) {
  const activePage = 'resourceCenter';
  const newHero = {
    ...hero,
    activePage,
    searchBox: {
      placeholder: 'Search',
      onEnter: (query) => {
        window.location.assign(`/resource-center/search?query=${query}`);
      },
    },
  };
  return (
    <div className={styles.blogHome}>
      {hero && <HeroTemplate {...newHero} />}
      <div className={styles.bgGrey} id="latest-resources">
        <div className={styles.container}>
          <div className={styles.section}>
            <BlogPostList
              title="Latest Resources"
              items={latestPosts}
              showListThumbnail
            />
          </div>
        </div>
      </div>
      {productBasedPosts.map((productPost, index) => {
        const key = `product-${index}`;
        return (
          <div
            className={index % 2 !== 0 ? styles.bgGrey : ''}
            key={key}
            id={productPost.id}
          >
            <div className={styles.container}>
              <div className={styles.section}>
                <BlogPostList
                  title={productPost.title}
                  items={productPost.posts}
                  seeAllLink={productPost.link}
                  highlightedPosition={index % 2 === 0 ? 'left' : 'right'}
                />
              </div>
            </div>
          </div>
        );
      })}
      {fullBgCard && <FullBGCard {...fullBgCard} />}
      {lcResources.length > 0 && (
        <div
          className={`${styles.container} ${styles.lcResourcesContainer}`}
          id="Resources"
        >
          <div className={styles.section}>
            <LcResources title="You May Also Like" lcResources={lcResources} />
          </div>
        </div>
      )}
    </div>
  );
}

BlogHome.propTypes = {
  hero: PropTypes.object,
  latestPosts: PropTypes.array,
  productBasedPosts: PropTypes.array,
  fullBgCard: PropTypes.object,
  lcResources: PropTypes.array,
};

export default BlogHome;
